export default theme => ({
  root: {
    backgroundColor: theme.palette.grey.eccoGrey,
    width: "100%",
    color: theme.palette.common.white,
    left: 0,
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(["4", 8], ["5", 10])
    },
    [theme.breakpoints.down("md")]: {
      padding: "24px 0px 24px 14px"
    },
  },

  itemDense: {
    padding: 0
  },

  LinkDense: {
    marginTop: 10,
    padding: 4,
    [theme.breakpoints.up("xs")]: {
      textAlign: "center"
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "left"
    },
  },

  LinkDense2: {
    /* padding: 4, */
    /* [theme.breakpoints.up("xs")]: {
      textAlign: "center"
    }, */
    [theme.breakpoints.up("md")]: {
    "&.MuiListItemText-root":{
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "60px"
    }},
    [theme.breakpoints.only("sm")]: {
      "&.MuiListItemText-root":{
          marginTop: 0,
          marginBottom: 0,
          marginLeft: "30px"
      }}
  },

  textDense: {
    margin: 0,
  },
  textDenseMobile: {
    margin: 0,
    marginLeft: 20
  },
 
  text: {
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(10)
    },

    fontWeight: theme.typography.fontWeightLight
  },

  textLink: {
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(16)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },
    
    fontWeight: theme.typography.fontWeightLight
  },

  borderRight: {
    [theme.breakpoints.up("xs")]: {
      borderRight: "1px solid"
    }
  },

  borderLeft: {
    height: "100%",
    marginTop: 15,
    [theme.breakpoints.up("xs")]: {
      borderLeft: "1px solid",
      borderRight: "1px solid"
    }
  },

  borderRight: {
    height: "100%",
    [theme.breakpoints.up("xs")]: {
      borderLeft: "1px solid"
    }
  },

  wrappedlogoSmg: {
    [theme.breakpoints.up("sm")]: {
      textAlign: "center"
    },
    [theme.breakpoints.down("xs")]: {
      borderLeft: "1px solid",
    }
  },

  line:{
    width:60,
    margin:0
  },

  wrappedLogoLegal: {
    padding: "2px 0",

    "& img": {
      width: 102,
      height: 50,

      "&:nth-child(1)": {
        paddingRight: theme.spacing(["5", 2])
      }
    },

    [theme.breakpoints.down("xs")]: {
      "& img": {
        width: 80,
        height: 50,
  
        "&:nth-child(1)": {
          paddingRight: theme.spacing(["5", 2])
        }
      },
    }
  },

  wrapper: {
    [theme.breakpoints.up("md")]: {
      alignItems: "center"
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }
  },

  smgImage: {
    [theme.breakpoints.down("xs")]: {
      height: 40,
      width: 120
    },
    // [theme.breakpoints.between("sm", "md")]: {
    //   height: 50,
    //   width: 135
    // },
    [theme.breakpoints.only("sm")]: {
      height: 40,
      width: 140
    },
    [theme.breakpoints.up("md")]: {
      height: 54,
      width: 172
    },
  
  },
  smgImageMobile: {
      height: 40,
      width: 140,
      marginLeft: "15%"
  },
  info:{
    [theme.breakpoints.only("sm")]: {
      marginTop: 10
    },
  }
});
